import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import index from '@/components/index'
import doudou from '@/components/doudou';
import glutinousRiceDog from "../components/glutinousRiceDog";
import appleRecruitment from "../components/appleRecruitment";
import radishRecruit from "../components/radishRecruit";
import manyPartTime from "../components/manyPartTime";
import baseWeb from '../components/baseWeb';
import duoduo from '../components/duoduo';
import strawberry from '../components/strawberry';
import wardrobeDiary from '../components/wardrobeDiary'
import smallFish from '../components/smallFish'
import earnChange from '../components/earnChange'
import guoguo from '../components/guoguo'
import newNmg from '../components/newNmg'
import elephant from '../components/elephantPartTime';
import pinDuoLe from '../components/pinDuoLe';
import partTimePackage from '../components/partTimePackage';

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [{
    path:'/',
    name:'',
    component: partTimePackage
  },
    {
      path:'/index',
      name:'index',
      component: index
    },//有檬兼职
    {
      path:'/doudou',
      name:'doudou',
      component: doudou
    },//兼职豆豆
    {
      path: '/glutinousRiceDog',
      name:'glutinousRiceDog',
      component: glutinousRiceDog
    },//糯米狗
    {
      path: '/appleRecruitment',
      name:'appleRecruitment',
      component: appleRecruitment
    },//苹果兼职
    {
      path: '/radishRecruit',
      name:'radishRecruit',
      component: radishRecruit
    },//兼职萝卜
    {
      path: '/manyPartTime',
      name:'manyPartTime',
      component: manyPartTime
    },//兼职多多
    // {
    //   path: '/baseWeb',
    //   name:'baseWeb',
    //   component: baseWeb
    // },
    {
      path: '/duoduo',
      name:'duoduo',
      component: duoduo
    },//兼职多多
    {
      path: '/strawberry',
      name:'strawberry',
      component: strawberry
    },//草莓兼职
    {
      path: '/wardrobeDiary',
      name:'wardrobeDiary',
      component: wardrobeDiary
    },//衣橱日记
    {
      path: '/smallFish',
      name:'smallFish',
      component: smallFish
    },//小鱼
    {
      path: '/earnChange',
      name:'earnChange',
      component: earnChange
    },//零钱赚
    {
      path: '/guoguo',
      name:'guoguo',
      component: guoguo
    },//果果兼职
    {
      path: '/newNmg',
      name:'newNmg',
      component: newNmg
    },//糯米狗（新）
    {
      path: '/elephant',
      name:'elephant',
      component: elephant
    },//大象兼职
    {
      path: '/pinDuoLe',
      name:'pinDuoLe',
      component: pinDuoLe
    },//拼多乐
    {
      path: '/partTimePackage',
      name:'partTimePackage',
      component: partTimePackage
    },//兼职包
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js